const CSRF = () => document.querySelector('meta[name="csrf-token"]')?.content;

async function request(path, options = {}) {
  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
    ...(options.headers || {}),
  };
  const token = CSRF();
  if (token) headers["X-CSRF-Token"] = token;

  const res = await fetch(`/portal/api${path}`, {
    credentials: "same-origin",
    ...options,
    headers,
  });

  const text = await res.text();
  let data = null;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    data = { error: "Invalid server response." };
  }

  if (!res.ok) {
    const err = new Error(data?.error || "Request failed.");
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}

export const portalApi = {
  me: () => request("/me"),
  login: (body) => request("/session", { method: "POST", body: JSON.stringify(body) }),
  verifyOtp: (body) => request("/session/otp", { method: "POST", body: JSON.stringify(body) }),
  logout: () => request("/session", { method: "DELETE" }),
  dashboard: () => request("/dashboard"),

  lists: {
    index: () => request("/mailing_lists"),
    show: (id) => request(`/mailing_lists/${id}`),
    create: (body) => request("/mailing_lists", { method: "POST", body: JSON.stringify(body) }),
    update: (id, body) => request(`/mailing_lists/${id}`, { method: "PATCH", body: JSON.stringify(body) }),
    destroy: (id) => request(`/mailing_lists/${id}`, { method: "DELETE" }),
    addSubscriber: (id, body) =>
      request(`/mailing_lists/${id}/subscribers`, { method: "POST", body: JSON.stringify(body) }),
    removeSubscriber: (listId, subscriberId) =>
      request(`/mailing_lists/${listId}/subscribers/${subscriberId}`, { method: "DELETE" }),
  },

  templates: {
    index: () => request("/email_templates"),
    show: (id) => request(`/email_templates/${id}`),
    create: (body) => request("/email_templates", { method: "POST", body: JSON.stringify(body) }),
    update: (id, body) => request(`/email_templates/${id}`, { method: "PATCH", body: JSON.stringify(body) }),
    destroy: (id) => request(`/email_templates/${id}`, { method: "DELETE" }),
  },

  campaigns: {
    index: () => request("/campaigns"),
    show: (id) => request(`/campaigns/${id}`),
    create: (body) => request("/campaigns", { method: "POST", body: JSON.stringify(body) }),
    update: (id, body) => request(`/campaigns/${id}`, { method: "PATCH", body: JSON.stringify(body) }),
    destroy: (id) => request(`/campaigns/${id}`, { method: "DELETE" }),
    send: (id) => request(`/campaigns/${id}/send`, { method: "POST" }),
  },

  smtp: {
    show: () => request("/smtp_settings"),
    update: (body) => request("/smtp_settings", { method: "PATCH", body: JSON.stringify(body) }),
    test: () => request("/smtp_settings/test", { method: "POST" }),
  },
};
